import React from "react";
import { ChevronLeft, ChevronRight, FileSearch, Search } from "lucide-react";
import PublicPageHero from "../PublicPageHero";
import SingleBlog from "./SingleBlog";

const BlogArchivePage = ({ title, description, data = [], loading, search, setSearch, page, setPage, count = 0, row = 12 }) => {
  const pages = Math.max(1, Math.ceil((count || data.length) / row));

  return (
    <main className="public-page public-blog-page" dir="rtl">
      <PublicPageHero eyebrow="مجله اینفینیتی" title={title} description={description || "راهنماها و تجربه‌های کاربردی برای تصمیم‌گیری بهتر در مسیر تحصیل و کار بین‌المللی"} />
      <section className="public-section">
        <div className="public-container">
          <div className="blog-toolbar">
            <div><h2>آخرین مطالب</h2><span>{new Intl.NumberFormat("fa-IR").format(count || data.length)} مطلب</span></div>
            <label><Search size={18} /><input value={search} onChange={(event) => { setSearch(event.target.value); setPage(1); }} placeholder="جست‌وجو در مطالب..." /></label>
          </div>

          {loading ? <div className="public-loading">در حال دریافت مطالب...</div> : data.length ? (
            <div className="blog-grid">{data.map((article, index) => <SingleBlog data={article} key={article.articleId || article.slug || index} />)}</div>
          ) : (
            <div className="public-empty"><span><FileSearch size={31} /></span><h3>مطلبی پیدا نشد</h3><p>عبارت دیگری را جست‌وجو کنید یا بعداً دوباره سر بزنید.</p></div>
          )}

          {pages > 1 && <nav className="public-pagination" aria-label="صفحه‌بندی مطالب">
            <button disabled={page === 1} onClick={() => setPage((value) => value - 1)} aria-label="صفحه قبلی"><ChevronRight size={18} /></button>
            <span>صفحه {new Intl.NumberFormat("fa-IR").format(page)} از {new Intl.NumberFormat("fa-IR").format(pages)}</span>
            <button disabled={page >= pages} onClick={() => setPage((value) => value + 1)} aria-label="صفحه بعدی"><ChevronLeft size={18} /></button>
          </nav>}
        </div>
      </section>
    </main>
  );
};

export default BlogArchivePage;
